import React, { useRef } from 'react';
import { IconX } from '@tabler/icons-react';
import { Button } from '../Button';

interface ConfirmModalProps {
  title: string;
  content: React.ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ title, content, onConfirm, onClose }) => {
  const overlayRef = useRef<HTMLDivElement>(null);

  return (
    <div
      className="mo open"
      ref={overlayRef}
      onClick={e => e.target === overlayRef.current && onClose()}
    >
      <div className="cm cm-create" style={{ maxWidth: 400 }}>
        <div className="cm-top" style={{ borderRadius: '20px 20px 0 0' }}>
          <div className="cm-ti">{title}</div>
          <div className="cm-sp" />
          <button className="cm-x" onClick={onClose} type="button">
            <IconX size={16} stroke={2} />
          </button>
        </div>
        <div className="cm-create-body" style={{ gap: 20, borderRadius: '0 0 20px 20px' }}>
          <div style={{ fontSize: 14, color: 'var(--text-secondary)' }}>{content}</div>
          <div className="adm-form-actions">
            <Button variant="adm-cancel" type="button" onClick={onClose}>
              Отмена
            </Button>
            <Button variant="primary" type="button" onClick={onConfirm}>
              Подтвердить
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ConfirmModal };
